import React from "react";
import {IQuestion} from "../../../data/interfaces/IQuestion";
import "./style.scss";


export function SwitchQuestionComponent(props: {
    question: IQuestion,
    onChange: (node: IQuestion) => void;
}) {

    const {question, onChange} = props;

    const options = [{text: "Да", value: 1}, {text: "Нет", value: 0}];

    const change = () => {
        question.isValid = !(question.selectedValue === undefined || (
            question.allowCustomAnswer === true
            && question.selectedValue === options[options.length - 1].value
            && (question.customAnswer === undefined || question.customAnswer.trim().length === 0)
        ));

        onChange(question);
    }

    return (
        <div className="survey-form-section">
            {
                (question.text !== undefined) && (
                    <label className="survey-form-section-label" htmlFor="name">
                        {question.text}
                    </label>
                )
            }

            <div className="survey-form-section-content">

                <div className="survey-form-radio-buttons-list">
                    {
                        options.map((option, optionIndex) => {
                            return (
                                <label className="survey-form-radio-button-container" key={optionIndex}>
                                    <input className="survey-form-radio-button-input"
                                           type="radio"
                                           name={question.id.toString()}
                                           onChange={(event) => {
                                               if (event.target.checked) {
                                                   question.selectedValue = option.value;
                                                   change();
                                               }
                                           }}
                                    />
                                    <span className="survey-form-radio-button-checkmark"></span>
                                    <span>{option.text}</span>
                                    <div className="survey-form-radio-button-outline-effect"></div>
                                </label>
                            )
                        })
                    }
                </div>

                {
                    (question.allowCustomAnswer === true && question.selectedValue === question.options.length) && (
                        <div className="survey-form-textarea-container">
                            <textarea
                                className="survey-form-input"
                                rows={6}
                                placeholder="Введите текст..."
                                value={question.customAnswer}
                                onChange={(event) => {
                                    question.customAnswer = event.target.value;
                                    change();
                                }}
                            />
                        </div>
                    )
                }
            </div>

        </div>
    )
}